import {ajax,getRequestUrl,formatData} from "../request";

export default {
  // 公会查询列表
  findFamilyList(data, method) {
    return ajax('post', getRequestUrl('/api/Family/findFamilyList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 保存公会信息接口
  saveFamilyUpdate(data, method) {
    return ajax('post', getRequestUrl('/api/Family/saveFamilyUpdate'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 解散公会
  deleteFamily(data, method) {
    return ajax('post', getRequestUrl('/api/Family/deleteFamily'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 公会工资锁定、解除锁定
  salaryLock(data, method) {
    return ajax('post', getRequestUrl('/api/Family/salaryLock'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 公会成员列表
  findFamilyMemberByPage(data, method) {
    return ajax('post', getRequestUrl('/api/Family/findFamilyMemberByPage'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 新增主播
  addFamilyMember(data, method) {
    return ajax('post', getRequestUrl('/api/Family/addFamilyMember'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 剔除公会成员
  deleteFromFamily(data, method) {
    return ajax('post', getRequestUrl('/api/Family/deleteFromFamily'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 公会统计
  guildStatistics(data, method) {
    return ajax('post', getRequestUrl('/api/Family/guildStatistics'), data, {
      method,
    })
  },

  // 领薪主播详情
  anchorDetail(data, method) {
    return ajax('post', getRequestUrl('/api/Family/anchorDetail'), data, {
      method,
    })
  },

  // top100支持者详情
  topAnchorDetail(data, method) {
    return ajax('post', getRequestUrl('/api/Family/topAnchorDetail'), data, {
      method,
    })
  },

  // 主播详情统计
  anchorList(data, method) {
    return ajax('post', getRequestUrl('/api/Family/anchorList'), data, {
      method,
    })
  },

  // 主播支持top30
  topAnchorSupport(data, method) {
    return ajax('post', getRequestUrl('/api/Family/topAnchorSupport'), data, {
      method,
    })
  },

  // 公会工资管理-总计
  guildSalaryTotal(data, method) {
    return ajax('post', getRequestUrl('/api/Family/guildSalaryTotal'), data, {
      method,
    })
  },

  // 公会工资管理——现金发放
  guildSalaryDetail(data, method) {
    return ajax('post', getRequestUrl('/api/Family/guildSalaryDetail'), data, {
      method,
    })
  },

  // 公会工资管理-审核
  auditingGuild(data, method) {
    return ajax('post', getRequestUrl('/api/Family/auditingGuild'), data, {
      method,
    })
  },

  // 添加现金发放
  cashPayment(data, method) {
    return ajax('post', getRequestUrl('/api/Family/cashPayment'), data, {
      method,
    })
  },

  // 异常主播
  abnormalList(data, method) {
    return ajax('post', getRequestUrl('/api/Family/abnormalList'), data, {
      method,
    })
  },

  //扣除魅力值
  abnormalDeduct(data, method) {
    return ajax('post', getRequestUrl('/api/Family/abnormalDeduct'), data, {
      method,
    })
  },

  //异常明细
  abnormalDetails(data, method) {
    return ajax('post', getRequestUrl('/api/Family/abnormalDetails'), data, {
      method,
    })
  },

  //异常收礼汇总
  unusualGiftReceiving(data, method) {
    return ajax('post', getRequestUrl('/api/Family/unusualGiftReceiving'), data, {
      method,
    })
  },

  //本月工资发放统计
  guildSalaryStatic(data, method) {
    return ajax('post', getRequestUrl('/api/Family/guildSalaryStatic'), data, {
      method,
    })
  },

  //用户申请创建公会审核列表
  applyToCreateAGguildList(data, method) {
    return ajax('post', getRequestUrl('/api/Family/applyToCreateAGguildList'), data, {
      method,
    })
  },

  //用户申请创建公会审核
  applyToCreateAGguild(data, method) {
    return ajax('post', getRequestUrl('/api/Family/applyToCreateAGguild'), data, {
      method,
    })
  },
}



// WEBPACK FOOTER //
// ./src/js/https/family.js